export const COLORS = {
    stuartBlue: '#4755ff',
    stuartGreen: '#27E2A5',
    blue: '#0052CC',
    darkBlue: '#00249C',
    white: '#FFFFFF',
    black: '#000000',
};
